/**
 * Simple boolean filter for array operations.
 * Usage: array.filter(truthy) to remove null/undefined/false values.
 */
export function truthy(value) {
  return Boolean(value);
}
